import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const sleepfitnessApiService = createApi({
  reducerPath: "sleepfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createSleep: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `sleepfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getSleep: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `sleepfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateSleep: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `sleepfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
    getChart: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `sleepfitness/chart-data${query}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateSleepMutation,
  useGetSleepQuery,
  useUpdateSleepMutation,
  useGetChartQuery,
} = sleepfitnessApiService;
